import {
  appConfigurationActions,
  viewFiltersSaved,
} from '../actions/appConfigurationActions'
import { createReducer } from '@reduxjs/toolkit'
import { set } from 'lodash/fp'
import { View } from 'models/View'

export interface IAppConfiguration {
  view: View
  sentimentRounding: boolean
}

const initialState: IAppConfiguration = {
  view: null,
  sentimentRounding: false,
}

const clearStateKey = (key: string) => (state: IAppConfiguration) =>
  set(key, null, state) as unknown as IAppConfiguration

const { setCurrentView, clearViewFilters, setSentimentRounding } =
  appConfigurationActions

const appConfigurationReducer = createReducer(initialState, builder => {
  builder
    .addCase(viewFiltersSaved, (state, { payload }) =>
      set('view', payload.view, state),
    )
    .addCase(setCurrentView, (state, action) => {
      const view = action.payload

      return set('view', view, state)
    })
    .addCase(setSentimentRounding, (state, action) => {
      return set('sentimentRounding', action.payload, state)
    })
    .addCase(clearViewFilters, clearStateKey('view.filters'))
    .addDefaultCase(state => state)
})

export default appConfigurationReducer
